const TYPOGRAPHY_MAP = {
  h0: "heading-xl",
  h1: "heading-xl",
  h2: "heading-lg",
  h3: "heading-md",
  h4: "heading-sm",
  h5: "heading-xs",
  h6: "body-bold",
  bodySmallHeading: "body-sm-bold",
  finePrintHeading: "fineprint-bold"
};
const RESPONSIVE_TYPOGRAPHY_MAP = Object.fromEntries(Object.entries(TYPOGRAPHY_MAP).map(([k, v]) => [k, `responsive.${v}`]));
function migrateTypographyToken(v8FontType) {
  if (!v8FontType) return v8FontType;
  return TYPOGRAPHY_MAP[v8FontType] ?? v8FontType;
}
function migrateTypographyTokenResponsive(v8FontType) {
  if (!v8FontType) return v8FontType;
  return RESPONSIVE_TYPOGRAPHY_MAP[v8FontType] ?? v8FontType;
}
const FONT_FAMILY_MAP = {
  sansSerif: "heading",
  serif: "heading-alt"
};
function migrateFontFamily(v8FontFamily) {
  if (!v8FontFamily) return v8FontFamily;
  return FONT_FAMILY_MAP[v8FontFamily] ?? v8FontFamily;
}
const SPACING_MAP = {
  none: "none",
  xxs: "tightest",
  xs: "tighter",
  sm: "default",
  md: "loose",
  lg: "looser",
  xl: "layout.looser",
  xxl: "layout.vast.default",
  xxxl: "layout.vast.loose"
};
const NEGATIVE_SPACING_MAP = Object.fromEntries(Object.entries(SPACING_MAP).filter(([k]) => k !== "none").map(([k, v]) => [`-${k}`, `-${v}`]));
const FULL_SPACING_MAP = {
  ...SPACING_MAP,
  ...NEGATIVE_SPACING_MAP
};
const GRIDBASE = 8;
const PX_TO_SPACING_NAME = Object.fromEntries(Object.entries({
  none: 0,
  xxs: 4,
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48
}).map(([k, px]) => [px, k]));
function migrateSpacingToken(v8Spacing) {
  if (v8Spacing === void 0 || v8Spacing === null || v8Spacing === "") return v8Spacing;
  if (v8Spacing in FULL_SPACING_MAP) return FULL_SPACING_MAP[v8Spacing];
  const num = Number(v8Spacing);
  if (!Number.isNaN(num) && num !== 0) {
    const px = GRIDBASE * num;
    const name = PX_TO_SPACING_NAME[px];
    if (name) return FULL_SPACING_MAP[name];
  }
  return v8Spacing;
}
const COLOR_MAP = {
  "": "text.neutral",
  textWhite: "text.onImpact.neutral-fixed",
  textMedium: "text.subtle",
  textLight: "text.subtle",
  textAqua: "text.accent.aqua.strong",
  textBrand: "text.accent.brand.hero",
  textDarkBlue: "text.accent.blue.strong",
  textDarkOrange: "text.accent.orange.strong",
  textDarkPurple: "text.accent.purple.strong",
  textGreen: "text.accent.green.strong",
  textOrange: "text.accent.orange.strong",
  textPurple: "text.accent.purple.strong",
  textTeal: "text.accent.teal.strong"
};
function migrateColorToken(v8Color) {
  if (v8Color === void 0 || v8Color === null) return v8Color;
  return COLOR_MAP[v8Color] ?? v8Color;
}
export {
  COLOR_MAP,
  FONT_FAMILY_MAP,
  FULL_SPACING_MAP,
  RESPONSIVE_TYPOGRAPHY_MAP,
  SPACING_MAP,
  TYPOGRAPHY_MAP,
  migrateColorToken,
  migrateFontFamily,
  migrateSpacingToken,
  migrateTypographyToken,
  migrateTypographyTokenResponsive
};
